/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Mon Jan 16 2023
 **/

import colors from "./colors";
import fontSize from "./fontSize";
import fontWeight from "./fontWeight";
import { Theme } from "@emotion/react";

const light: Theme = {
	mainColor: "#fff",
	rootFontSize: "16px",
	font: fontSize,
	weight: fontWeight,
	colors
};

export default { light };
